import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faDownload } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'

class LotDeliveryDocuments extends Component {
  // Always resolve a fresh presigned URL for the document instead of relying
  // on the stored (and potentially expired) document.url
  async openDocLink(doc) {
    try {
      const res = await axios(`lots/documents/${doc.key}/signed-url`, {
        method: 'get'
      })

      return res?.data?.url || ''
    } catch (err) {
      console.error('Failed to get document URL:', err)
      return ''
    }
  }

  render() {
    const documents = this.props.documents || []

    if (!documents.length) {
      return null
    }

    return (
      <div className='lot-documents delivery-documents'>
        <div className='row'>
          <div className='row-title-wrap'>
            <p className='row-title'>{this.props.title}</p>
          </div>
          <div className='documents-container'>
            {documents.map((doc, i) => {
              return (
                <div className='option document-row documents' key={doc.key || i}>
                  <div className='file-wrap'>
                    <p className='description'>{doc.description}</p>
                    <a
                      className='view-link'
                      href='#'
                      onClick={async (e) => {
                        e.preventDefault()
                        const url = await this.openDocLink(doc)
                        if (url) window.open(url, '_blank')
                      }}
                    >
                      <span>View </span>
                      <FontAwesomeIcon icon={faSearch} />
                    </a>
                    <a
                      className='download-link'
                      href='#'
                      onClick={async (e) => {
                        e.preventDefault()
                        const url = await this.openDocLink(doc)
                        if (url) window.open(url, '_blank')
                      }}
                    >
                      <span>Download</span>
                      <FontAwesomeIcon icon={faDownload} />
                    </a>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

LotDeliveryDocuments.propTypes = {
  documents: PropTypes.array,
  title: PropTypes.string
}

LotDeliveryDocuments.defaultProps = {
  documents: [],
  title: 'Documents'
}

export default LotDeliveryDocuments
